import gql from "graphql-tag";
const NEWS = gql`
	query (
		$where: NewsQueryResponseFilterInput
		$order: [NewsQueryResponseSortInput!]
		$skip: Int
		$take: Int
	) {
		items: userNewsWithLike(
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				isLiked
				isDisliked
				likesCount
				dislikesCount
				isFavorite
				entity {
					id
					code
					title
					plainContent
					publishedOn
					titleVideo
					titleFileId
					tags {
						id
						name
					}
					contacts {
						id
						name
						photoId
						preset
					}
				}
			}
		}
	}
`;
const NEWS_WITH_CONTENT = gql`
	query ($where: NewsQueryResponseFilterInput) {
		items: userNewsWithLike(where: $where) {
			items {
				isLiked
				isDisliked
				likesCount
				dislikesCount
				isFavorite
				entity {
					id
					code
					title
					plainContent
					publishedOn
					titleVideo
					titleFileId
					hideTitleInCard
					tags {
						id
						name
					}
					contacts {
						id
						name
						photoId
						preset
					}
					content
					metaTitle
					metaDescription
				}
			}
		}
	}
`;
const NEWS_ADDITIONAL_DATA = gql`
	query ($where: NewsFilterInput) {
		items: userNews(where: $where) {
			items {
				content
				metaTitle
				metaDescription
			}
		}
	}
`;
const NEWS_FOR_EDIT = gql`
	query ($where: NewsFilterInput) {
		items: userNewsNoLocale(where: $where) {
			items {
				id
				code
				title
				plainContent
				publishedOn
				titleVideo
				titleFileId
				hideTitleInCard
				tags {
					id
					name
				}
				contacts {
					id
					name
					photoId
				}
				content
				metaTitle
				metaDescription
				group {
					id
					name
				}
				culture {
					id
				}
			}
		}
	}
`;
const NEWS_COMMENTS = gql`
	query (
		$where: NewsCommentQueryResponseFilterInput
		$order: [NewsCommentQueryResponseSortInput!]
		$skip: Int
		$take: Int
	) {
		items: newsCommentsWithLike(
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				comment {
					id
					text
					author {
						id
						name
						photoId
					}
					createdOn
					parentId
				}
				isLikedByMe
				reactionsCount
				childrenCount
			}
		}
	}
`;
const NEWS_TAGS = gql`
	query (
		$where: TagFilterInput
		$order: [TagSortInput!]
		$skip: Int
		$take: Int
	) {
		newsTags(where: $where, order: $order, skip: $skip, take: $take) {
			__pageInfo: pageInfo {
				hasNextPage
			}
			__items: items {
				id
				name
			}
		}
	}
`;
const DELETE_NEWS_TAG = gql`
	mutation ($id: UUID!) {
		deleteNewsTag(id: $id)
	}
`;
const ADD_OR_EDIT_NEWS = gql`
	mutation ($inputs: [NewsInput!]!) {
		result: addOrEditNews(inputs: $inputs)
	}
`;
const DELETE_NEWS = gql`
	mutation ($code: String!) {
		deleteNews(code: $code)
	}
`;
const NEWS_GROUPS_LOOKUP = gql`
	query ($where: NewsGroupFilterInput, $order: [NewsGroupSortInput!]) {
		newsGroups(where: $where, order: $order) {
			id
			name
			parentId
		}
	}
`;
const NEWS_GROUPS_WITH_COUNTERS = gql`
	query {
		newsGroupWithCounters {
			id
			name
			isSystem
			isHidden
			position
			parentId
			newsCountBySubGroup
		}
	}
`;
const ADD_OR_EDIT_NEWS_GROUPS = gql`
	mutation ($inputs: [NewsGroupInput!]!) {
		result: addOrEditNewsGroups(inputs: $inputs) {
			id
		}
	}
`;
const DELETE_NEWS_GROUP = gql`
	mutation ($id: UUID!) {
		deleteNewsGroup(id: $id)
	}
`;
const ADD_NEWS_COMMENT = gql`
	mutation ($input: NewsCommentInput!) {
		addNewsComment(input: $input) {
			id
		}
	}
`;
const ADD_NEWS_COMMENT_REACTION = gql`
	mutation ($input: CommentReactionInput!) {
		addNewsCommentReaction(input: $input) {
			count
			isLiked
		}
	}
`;
const ADD_NEWS_REACTION = gql`
	mutation ($input: BaseEntityReactionInput!) {
		addNewsReaction(input: $input) {
			isLiked
			isDisliked
			likesCount
			dislikesCount
		}
	}
`;
export {
  ADD_NEWS_COMMENT,
  ADD_NEWS_COMMENT_REACTION,
  ADD_NEWS_REACTION,
  ADD_OR_EDIT_NEWS,
  ADD_OR_EDIT_NEWS_GROUPS,
  DELETE_NEWS,
  DELETE_NEWS_GROUP,
  DELETE_NEWS_TAG,
  NEWS,
  NEWS_ADDITIONAL_DATA,
  NEWS_COMMENTS,
  NEWS_FOR_EDIT,
  NEWS_GROUPS_LOOKUP,
  NEWS_GROUPS_WITH_COUNTERS,
  NEWS_TAGS,
  NEWS_WITH_CONTENT
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
